import { setupFormState } from '@/components/form/tidal-form'

import { VoiceFormValues } from './typings'

export const form = setupFormState<VoiceFormValues>({
  id: 'voiceForm',
  initialValues: {
    id: '',
    status: 'OFF',
    forbidDriverCallsToCompletedOrderSteps: false,
    forbidDriverCallsToIncompleteOrderSteps: false,
    callbackConfigStatus: 'OFF',
    backOfficePhone: '',
    automatedMessageEnabled: 'OFF',
    automatedMessage: '',
    automatedMessageVoice: 'FEMALE',
  },
})
